import React from 'react';

// class FixedScroll extends Component {
const FixedScroll = props => {
  return (
    <div
      className={`fv-fixed-scroll ${
        props.isSticky ? 'fv-fixed-scroll--sticky' : ''
      }`}
    >
      {props.children}
    </div>
  );
};

export default FixedScroll;
